import EventFilter from "./components/Video/Filter/eventFilter";
import { AttachModeKind, type AttachModeTarget, type EventFilterValue, FilterCategory, type MergedGpEventResponse } from "./types";

export const ATTACH_CLIPS_MAX = 6;

export function cloneFilterValues(filterValues: EventFilterValue[]): EventFilterValue[] {
	return filterValues.map((filterValue) => ({
		key: filterValue.key,
		value: [...filterValue.value],
	}));
}

export function isTeamOrPlayerFilterKey(eventFilter: EventFilter, key: string): boolean {
	const filterCategory = eventFilter.getFilterCategory(key);
	return filterCategory === FilterCategory.Team || filterCategory === FilterCategory.Player;
}

export function buildLockedFilterValues(eventFilter: EventFilter, target: AttachModeTarget): EventFilterValue[] {
	if (target.kind === AttachModeKind.Team) {
		const teamFilterView = eventFilter.getFilterView(target.filterKey);
		if (teamFilterView === undefined) {
			return [];
		}

		return eventFilter.mutateFilterValues([], target.filterKey, teamFilterView.value || target.filterKey, true);
	}

	return eventFilter.mutateFilterValuesByPlayerId([], target.playerId);
}

export function mergeFiltersWithAttachLock(eventFilter: EventFilter, filterValues: EventFilterValue[], target: AttachModeTarget): EventFilterValue[] {
	const lockedFilterValues = buildLockedFilterValues(eventFilter, target);
	const otherFilterValues = cloneFilterValues(
		filterValues.filter((filterValue) => isTeamOrPlayerFilterKey(eventFilter, filterValue.key) === false)
	);

	return [...lockedFilterValues, ...otherFilterValues];
}

export function isSameAttachTarget(current: AttachModeTarget | null, next: AttachModeTarget): boolean {
	if (current === null) {
		return false;
	}

	if (current.kind === AttachModeKind.Team && next.kind === AttachModeKind.Team) {
		return current.teamId === next.teamId;
	}

	if (current.kind === AttachModeKind.Player && next.kind === AttachModeKind.Player) {
		return current.playerId === next.playerId;
	}

	return false;
}

export function getAttachTargetKey(target: AttachModeTarget): string {
	if (target.kind === AttachModeKind.Team) {
		return `team:${target.teamId}`;
	}

	return `player:${target.playerId}`;
}

export function hasAttachSelectionChanged(attachedEvents: MergedGpEventResponse[], selectedEvents: MergedGpEventResponse[]): boolean {
	if (attachedEvents.length !== selectedEvents.length) {
		return true;
	}

	const attachedEventIds = new Set(attachedEvents.map((mergedEvent) => mergedEvent.id));

	return selectedEvents.some((mergedEvent) => attachedEventIds.has(mergedEvent.id) === false);
}
